export const tankManufacturerOptions = [
  { value: '태광', label: '태광' },
  { value: '일진', label: '일진' },
  { value: '시노마', label: '시노마' },
];

export const valveManufacturerOptions = [
  { value: '태광', label: '태광' },
  { value: '영도', label: '영도' },
];

export const valveVersionOptions = [
  { value: 'V01', label: 'V01' },
  { value: 'V02', label: 'V02' },
  { value: 'V03', label: 'V03' },
  { value: 'V03-1', label: 'V03-1' },
  { value: 'V04', label: 'V04' },
  { value: 'V05', label: 'V05' },
  { value: 'V06', label: 'V06' },
  { value: 'V07', label: 'V07' },
  { value: 'V08', label: 'V08' },
  { value: 'V09', label: 'V09' },
  { value: 'V10', label: 'V10' },
];
